import createFocusTrap from 'focus-trap';
import { detectMobileDevice } from '../../helpers/mobile.js';

const TOUCH_OPEN_TIMEOUT = 45 * 1000;

export default class Modal {

    constructor(element = null) {
        this.element = element;
        this.id = this.element.id;
        this.storageKey = `modal-${this.id}`;
        this.dialog = this.element.querySelector('.c-modal__dialog');
        this.setHashOnOpen = this.element.dataset.modalSetHash !== "false";

        this.initClose();
        this.addEventListeners();
        this.initFocusTrap();

        if(location.hash.substr(1) == this.id) {
            location.hash = '#';
            this.open();
        }

        if(this.element.dataset.modalOpen === 'exitIntent') {
            this.openOnExitIntent();
        }
    }

    initClose() {
        this.closeElement = this.element.querySelector('.c-modal__close');

        if (this.closeElement) {
            this.closeElement.addEventListener('click', event => {
                event.preventDefault();
                this.close();
            })

            window.addEventListener('keydown', event => {
                if(event.key !== 'Escape' && event.key !== 'Esc') {
                    return;
                }

                this.close();
            });
        }
    }

    initFocusTrap() {
        if (this.focusTrap) {
            return;
        }

        const firstFocusable = this.dialog.querySelector('input, textarea, select, a, button');

        if (!this.closeElement && !firstFocusable) {
            return;
        }

        this.focusTrap = createFocusTrap(this.dialog, {
            initialFocus: this.closeElement || firstFocusable,
        });
    }

    addEventListeners() {
        document.querySelectorAll(`[href="#${this.id}"]`).forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                this.open();
            });
        });
    }

    isOpen() {
        return this.element.getAttribute('aria-hidden') === 'false';
    }

    isDismissed() {
        return localStorage.getItem(this.storageKey) === 'DISMISSED';
    }

    open() {
        if(this.isOpen()) {
            return;
        }

        if (this.setHashOnOpen) {
            this.setHash(this.id);
        }

        this.element.setAttribute('aria-hidden', 'false');

        if (this.focusTrap) {
            this.focusTrap.activate();
        }

        document.body.style.overflow = 'hidden';
    }

    close() {
        if(!this.isOpen()) {
            return;
        }

        this.setHash('');
        this.element.setAttribute('aria-hidden', 'true');
        console.log(this.focusTrap);

        if (this.focusTrap) {
            console.log("Pausing focus trap");
            this.focusTrap.pause();
        }

        document.body.style.overflow = null;
        localStorage.setItem(this.storageKey, 'DISMISSED');
    }

    openOnExitIntent() {
        const isMobile = detectMobileDevice() !== false;

        const open = () => {
            if (
                !this.isDismissed() &&
                !this.hasVisibleCookieDialogs() &&
                !this.hasVisibleModals()
            ) {
                this.open();
            }
        };

        document.documentElement.addEventListener('mouseleave', (event) => {
            const padding = 50;

            if (event.clientY < (window.innerHeight - padding)) {
                open();
            }
        });

        if (isMobile) {
            setTimeout(open, TOUCH_OPEN_TIMEOUT);
        }
    }

    setHash(hash) {
        if(!history.replaceState) {
            return location.hash = `#${hash}`;
        }

        history.replaceState(null, '', `#${hash}`);
    }

    hasVisibleCookieDialogs() {
        // This is a workaround to check that neither the initial CookieHub dialog
        // nor the settings dialog is open.
        const dialogs = Array.from(document.querySelectorAll('.ch2-dialog, .ch2-settings'));

        return dialogs.some((dialog) => {
            const style = getComputedStyle(dialog);
            return style.visibility !== 'hidden' && style.display !== 'none';
        });
    }

    hasVisibleModals() {
        const modals = Array.from(document.querySelectorAll('.c-modal[aria-hidden="false"]'));
        return modals.length > 0;
    }

}
